import {
  faDownload,
  faMinus,
  faPlus,
  faTrash,
  faXmark,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Option, Select, Textarea } from "@mui/joy";
import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CardFooter,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Form } from "reactstrap";
import { formatAmount, formatDateTimeUS } from "../../components/Common";
import SharedBeneficiary from "../../components/SharedBeneficiary";
import SideBar from "../../components/sidebar/Sidebar";
import UserBase from "../../components/user/UserBase";
import "../../css/formPOPup.css";
import "../../css/myestare.css";
import {
  addJewelries,
  deleteJewelry,
  getJewelries,
  updateJewelriesNetWorthStatus,
  updateJewelriesPublicStatus,
  updateDocumentApi,
} from "../../services/JewelryService";
import {
  deleteSingleProperty,
  downloadDocument1,
  fetchNetWorth,
  getBeneficiary,
  getOwnerByUserId,
  getSecondaryUser,
  getToken,
  getTrustByUserId,
  getUser,
} from "../../services/user-service";
import { ConfirmationPopup } from "./ConfirmationPopup";
import Deletebutton from "./Deletebutton";
import UpdateButton from "./UpdateButton";
import { getCachedGoldPrice } from "./GoldPrice";
import { getCachedSilverPrice } from "./SilverPrice";
import { getCachedPalladiumPrice } from "./PalladiumPrice";
const getInitialJewelryData = () => ({
  jewelry: {
    jewelryListName: "",
    owner: "",
    jewelryCaption: "",
    jewelryName: "",
    otherJewelryName: "",
    quantity: "",
    perQuantityValue: "",
    estimatedValue: "",
    isPartOfNetWorth: "true",
    isPublic : "false",
    caratValue: "",
    weight: "",
    trust: "",
    beneficiaryName: "",
    notes: "",
  },
  sharedDetails: [
    {
      distributedType: "",
      distributedValue: "",
      distributedAmount: "",
      beneficiaryId: "",
    },
  ],
});

const roundToTwoDecimals = (num) => {
  return Math.round(num * 100) / 100;
};
const formatToTwoDecimals = (num) => Number(num).toFixed(2);

function JewelryList() {
  const [jewelries, setJewelries] = useState([getInitialJewelryData()]);
  const [files, setFiles] = useState([]);

  const [modal, setModal] = useState(false);
  const [jewelryListNameValue, setJewelryListNameValue] = useState("");
  const handleChangeAddJewelryListName = (event) => {
    const value = event.target.value;
    setJewelryListNameValue(value);
  };
  const handleChangeConfirm = () => {
    if (jewelryListNameValue !== "") {
      setJewelries((prevJewelries) => {
        const updatedJewelries = [...prevJewelries];

        updatedJewelries[0].jewelry.jewelryListName = jewelryListNameValue;
        return updatedJewelries;
      });
      setForm1(!form1);
    }
    toggleJewelryList();
  };
  const toggleJewelryList = () => {
    setModal(false);
  };

  const [errors, setErrors] = useState({});

  // for owner field
  const [ownerName, setOwnerName] = useState([]);
  const handleChange = (event, newValue, field, index, type = "jewelry") => {
    if (field === "caratValue" || field === "jewelryName") {
      setJewelries((prevJewelries) =>
        prevJewelries.map((item, i) =>
          i === index
            ? {
                ...item,
                [type]: {
                  ...item[type],
                  [field]: newValue,
                  otherJewelryName:
                    field === "jewelryName" && newValue !== "Other" ? "" : "",
                },
              }
            : item
        )
      );
    }

    if (field === "owner") {
      const ownerString = Array.isArray(newValue)
        ? newValue.join(", ")
        : newValue;

      setJewelries((prevJewelries) =>
        prevJewelries.map((item, i) =>
          i === index
            ? {
                ...item,
                [type]: {
                  ...item[type],
                  owner: ownerString,
                },
              }
            : item
        )
      );

      setOwnerName((prevOwnerNames) => {
        const updatedOwnerNames = [...prevOwnerNames];
        updatedOwnerNames[index] = newValue;
        return updatedOwnerNames;
      });
    }
  };

  // Define an array to store user names
  const [ownerNames, setOwnerNames] = useState([]);

  // Get primaryUser data
  const primaryUserDetails = getUser();
  const primaryUserName =
    primaryUserDetails.firstName + " " + primaryUserDetails.lastName;

  // Get secondaryUser data
  const secondaryUserDetails = getSecondaryUser();
  useEffect(() => {
    const fetchOwnerData = async () => {
      const userId = getUser().commonId;
      const token = "Bearer " + getToken();

      try {
        const resp = await getOwnerByUserId(token, userId);
        // Process data after fetching
        const names = [primaryUserName];

        // Check if secondary user exists
        if (secondaryUserDetails !== undefined) {
          const secondaryUserName = `${secondaryUserDetails.firstName} ${secondaryUserDetails.lastName}`;
          names.push(secondaryUserName);
        }
        resp.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          names.push(fullName);
        });

        // Update ownerNames state
        setOwnerNames(names);
      } catch {
        toast.error("Failed to fetch owner data");
      }
    };

    fetchOwnerData();
  }, []);
  const [weightUnit, setWeightUnit] = useState("gm");

  const [assetIndexValue, setAssetIndexValue] = useState(0);
  const [sharedTypeArray, setSharedTypeArray] = useState([]); // Initialize as an array
  const handleChanges = (e, field, index, type = "jewelry") => {
    setAssetIndexValue(index);
    const value = typeof e === "object" && e?.target ? e.target.value : e;
    if (
      [
        "weight",
        "quantity",
        "caratValue",
        "silverPurity",
        "unit",
        "purity",
      ].includes(field) &&
      type === "jewelry"
    ) {
      const current = jewelries[index]?.[type] || {};
      const updatedJewelry = {
        ...current,
        [field]: value,
      };

      const name = updatedJewelry?.jewelryName?.toLowerCase();
      const weight = parseFloat(updatedJewelry?.weight || 0);
      const quantity = parseFloat(updatedJewelry?.quantity || 0);
      const caratValue = updatedJewelry?.caratValue;
      const unit = updatedJewelry?.unit || "gm";
      const convertedWeight = unit === "oz" ? weight * 31.1035 : weight;
      // ---- GOLD CALCULATION ---- //

      if (name === "gold" && caratValue && weight && quantity) {
        const caratFormatted = `${caratValue}K`;
        getCachedGoldPrice().then((prices) => {
          const pricePerGram = parseFloat(prices[caratFormatted]?.perGram || 0);
          const rawPerValue = pricePerGram * convertedWeight;
          const rawEstValue = rawPerValue * quantity;
          const perValue = roundToTwoDecimals(rawPerValue).toFixed(2);
          const estValue = roundToTwoDecimals(rawEstValue).toFixed(2);
          setJewelries((prev) => {
            const updated = [...prev];
            updated[index][type] = {
              ...updatedJewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            };
            return updated;
          });
        });
        return;
      }
      // ---- SILVER CALCULATION ---- //
      if (name === "silver" && caratValue && weight && quantity) {
        const purity = parseFloat(caratValue);
        getCachedSilverPrice().then((pricePerGram) => {
          const silverRate = parseFloat(pricePerGram || 0);
          const rawPerValue = silverRate * purity * convertedWeight;
          const rawEstValue = rawPerValue * quantity;
          const perValue = roundToTwoDecimals(rawPerValue).toFixed(2);
          const estValue = roundToTwoDecimals(rawEstValue).toFixed(2);
          setJewelries((prev) => {
            const updated = [...prev];
            updated[index][type] = {
              ...updatedJewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            };
            return updated;
          });
        });
        return;
      }

      // ---- PALLADIUM CALCULATION ---- //
      if (name === "palladium" && caratValue && weight && quantity) {
        const purity = parseFloat(caratValue);
        const convertedWeight = unit === "oz" ? weight * 31.1035 : weight;

        getCachedPalladiumPrice("gram").then((basePricePerGram) => {
          const palladiumRate = parseFloat(basePricePerGram || 0);

          const rawPerValue = palladiumRate * purity * convertedWeight;
          const rawEstValue = rawPerValue * quantity;
          const perValue = roundToTwoDecimals(rawPerValue).toFixed(2);
          const estValue = roundToTwoDecimals(rawEstValue).toFixed(2);

          setJewelries((prev) => {
            const updated = [...prev];
            updated[index][type] = {
              ...updatedJewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            };
            return updated;
          });
        });

        return;
      }

      if (field === "unit") {
        setJewelries((prev) => {
          const updated = [...prev];
          updated[index][type] = {
            ...updated[index][type],
            [field]: value,
          };
          return updated;
        });
        return;
      }
    }
    if (field === "sharedType") {
      setSharedTypeArray((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });

      setJewelries((prevJewelries) => {
        const updatedJewelries = [...prevJewelries];
        updatedJewelries[index].sharedDetails = [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ];
        return updatedJewelries;
      });
      setJewelries((prevJewelries) =>
        prevJewelries.map((jewelry, i) => {
          return i === index
            ? {
                ...jewelry,
                [type]: {
                  ...jewelry[type],
                  trust: "",
                },
              }
            : jewelry;
        })
      );
      setJewelries((prevJewelries) =>
        prevJewelries.map((jewelry, i) => {
          return i === index
            ? {
                ...jewelry,
                [type]: {
                  ...jewelry[type],
                  beneficiaryName: "",
                },
              }
            : jewelry;
        })
      );
    } else {
      setJewelries((prevJewelries) =>
        prevJewelries.map((jewelry, i) => {
          if (field === "perQuantityValue" && i === index) {
            const quantity = parseFloat(jewelry[type].quantity || 0);
            const newValue = parseFloat(value || 0);
            const rawEstimatedValue = quantity * newValue;

            return {
              ...jewelry,
              [type]: {
                ...jewelry[type],
                perQuantityValue: value,
                estimatedValue:
                  roundToTwoDecimals(rawEstimatedValue).toFixed(2),
              },
            };
          }

          if (field === "quantity" && i === index) {
            const newQuantity = parseFloat(value || 0);
            const perValue = parseFloat(jewelry[type].perQuantityValue || 0);
            const rawEstimatedValue = newQuantity * perValue;

            return {
              ...jewelry,
              [type]: {
                ...jewelry[type],
                quantity: value,
                estimatedValue:
                  roundToTwoDecimals(rawEstimatedValue).toFixed(2),
              },
            };
          }
          return i === index
            ? {
                ...jewelry,
                [type]: {
                  ...jewelry[type],
                  [field]: value,
                },
              }
            : jewelry;
        })
      );
    }
  };
  useEffect(() => {
    const updateGoldJewelryValues = async () => {
      const prices = await getCachedGoldPrice();
      setJewelries((prev) =>
        prev.map((item) => {
          const { jewelry } = item;
          const isGold = jewelry?.jewelryName?.toLowerCase() === "gold";
          const caratKey = `${parseInt(jewelry?.caratValue)}K`;

          if (!isGold || !prices[caratKey]) return item;

          const pricePerGram = prices[caratKey];
          const unit = (jewelry?.unit || "gram").toLowerCase();
          const weight = parseFloat(jewelry?.weight || 0);
          const quantity = parseFloat(jewelry?.quantity || 0);
          const convertedWeight = unit === "oz" ? weight * 31.1035 : weight;

          const perValue = (pricePerGram * convertedWeight).toFixed(2);
          const estValue = (
            pricePerGram *
            convertedWeight *
            quantity
          ).toFixed(2);

          return {
            ...item,
            jewelry: {
              ...jewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            },
          };
        })
      );
    };
    updateGoldJewelryValues();
  }, []);

  useEffect(() => {
    const updateSilverJewelryValues = async () => {
      const silverPrice = await getCachedSilverPrice(); // your own utility function
      setJewelries((prev) =>
        prev.map((item) => {
          const { jewelry } = item;
          const isSilver = jewelry.jewelryName?.toLowerCase() === "silver";
          if (!isSilver || !silverPrice) return item;

          const unit = jewelry?.unit || "gram";
          const weight = parseFloat(jewelry.weight || 0);
          const quantity = parseFloat(jewelry.quantity || 0);
          const perValue = (silverPrice * weight).toFixed(2);
          const estValue = (silverPrice * weight * quantity).toFixed(2);

          return {
            ...item,
            jewelry: {
              ...jewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            },
          };
        })
      );
    };

    updateSilverJewelryValues();
  }, []);
  useEffect(() => {
    const updatePalladiumJewelryValues = async () => {
      const palladiumPrice = await getCachedPalladiumPrice(); // default = per gram
      setJewelries((prev) =>
        prev.map((item) => {
          const { jewelry } = item;
          const isPalladium =
            jewelry?.jewelryName?.toLowerCase() === "palladium";
          if (!isPalladium || !palladiumPrice || !jewelry?.purity) return item;

          const purity = parseFloat(jewelry.purity);
          const unit = (jewelry.unit || "gram").toLowerCase();
          const weight = parseFloat(jewelry.weight || 0);
          const quantity = parseFloat(jewelry.quantity || 0);
          const convertedWeight = unit === "oz" ? weight * 31.1035 : weight;

          const perValue = (
            palladiumPrice *
            purity *
            convertedWeight
          ).toFixed(2);
          const estValue = (
            palladiumPrice *
            purity *
            convertedWeight *
            quantity
          ).toFixed(2);

          return {
            ...item,
            jewelry: {
              ...jewelry,
              perQuantityValue: perValue,
              estimatedValue: estValue,
            },
          };
        })
      );
    };

    updatePalladiumJewelryValues();
  }, []);

  const getColumnTitleForJewelry = (type) => {
    switch (type) {
      case "Gold":
        return "Carat*";
      case "Silver":
        return "Purity*";
      case "Platinum":
      case "Palladium":
        return "Purity (%)*";
      case "Stone":
        return "Quality Grade*";
      case "Other":
        return "Detail*";
      default:
        return "Carat/Purity*";
    }
  };

  const getPlaceholderForJewelry = (type) => {
    switch (type) {
      case "Gold":
        return "Select Carat";
      case "Silver":
        return "Select Purity";
      case "Platinum":
      case "Palladium":
        return "Select Purity (%)";
      case "Stone":
        return "Select Grade";
      case "Other":
        return "Enter Detail";
      default:
        return "Select Value";
    }
  };


  const resetForm = () => {
    setFiles([]);
    setOwnerName([]);
    setJewelries([getInitialJewelryData()]);
    setSharedTypeArray([]);
    setIsTextFieldClicked(false);
    setJewelryListNameValue("");
    handleReset();
  };

  const funcNetWorthStatus = () => {
    updateJewelriesNetWorthStatus(
      existingJewelryListName,
      isChecked === true ? "false" : "true"
    )
      .then((resp) => {
        toast.success(resp, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        AddCard();
      })
      .catch((error) => {});
  };

  const [isChecked, setIsChecked] = useState(null);
  const handleSwitchChange = () => {
    setIsChecked(!isChecked);
    funcNetWorthStatus();
  };

  const [isPublic, setIsPublic] = useState(false);

  const handleSwitchChange1 = () => {
    const newStatus = !isPublic;
    setIsPublic(newStatus);
    funcPublicStatus(newStatus);
  };

  const funcPublicStatus = (newStatus) => {
    if (!Array.isArray(showDetail) || showDetail.length === 0) return;

    const listName = showDetail[0].jewelry.jewelryListName;
    const newStatusString = newStatus ? "true" : "false";

    updateJewelriesPublicStatus(listName, newStatusString)
      .then(() => {
        toast.success("Public status updated successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
        });

        const updatedShowDetail = showDetail.map((item) => ({
          ...item,
          jewelry: { ...item.jewelry, isPublic: newStatusString },
        }));
        setShowDetail(updatedShowDetail);

        AddCard();
      })
      .catch(() => {
        toast.error("Failed to update public status", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setIsPublic(!newStatus);
      });
  };

  // Set the form
  const jewelryForm = (event) => {
    event.preventDefault();
    const newErrors = {};

    const row = jewelries[0].jewelry;

    if (!row.owner)
      newErrors.owner = "Please select an owner.";

    if (!row.jewelryName)
      newErrors.jewelryName = "Please select metal type.";

    if (!row.jewelryCaption)
      newErrors.jewelryCaption = "Metal name is required.";

    if (!row.caratValue)
      newErrors.caratValue = "Carat/Purity is required.";

    if (!row.weight)
      newErrors.weight = "Weight is required.";

    if (!row.quantity)
      newErrors.quantity = "Quantity is required.";

    if (!row.perQuantityValue)
      newErrors.perQuantityValue = "Rate is required.";

    const beneficiarySelected =
        (jewelries[0].sharedDetails &&
            jewelries[0].sharedDetails.length > 0 &&
            jewelries[0].sharedDetails[0].distributedType !== "") ||
        row.trust ||
        row.beneficiaryName;

    if (!beneficiarySelected)
      newErrors.beneficiary = "Please select a beneficiary.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    let token = "Bearer " + getToken();

    // create form data to send a file and remaining class data
    const formData = new FormData();

    formData.append("data", JSON.stringify(jewelries));

    Object.keys(files).forEach((index) => {
      files[index].forEach((file) => {
        formData.append(`files${index}`, file);
      });
    });



    addJewelries(formData, token)
      .then((resp) => {
        AddCard();
        toast.success("Data Added !!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });

        fetchNetWorth(primaryUserDetails.commonId);
        toggle(null, null, null, "close");
      })
      .catch((error) => {});
  };

  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentIdType, setCurrentIdType] = useState("");
  const removeJewelry = (id, idType) => {
    setShowConfirmationDelete(true);
    setCurrentId(id);
    setCurrentIdType(idType);
  };

  const handleConfirmationDeleteClose = () => {
    setShowConfirmationDelete(false);
  };

  // Code by Purnendu
  const handleRemove = (params) => {
    setShowConfirmationDelete(false);
    const { Id, idType } = params;
    if (idType === "jewelryId") {
      deleteJewelry(Id)
        .then((res) => {
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          AddCard();
          setShow1(false);
        })
        .catch((error) => {});
    } else {
      deleteSingleProperty(Id)
        .then((res) => {
          setBeneficiaryVisible(!beneficiaryVisible);
          setShow1(false);
          AddCard();
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
        })
        .catch((error) => {});
    }
  };

  const handleDownload = (id, fileName) => {
    let myarry = fileName.split(".");

    downloadDocument1(id)
      .then((response) => {
        const downloadUrl = URL.createObjectURL(response.data);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${myarry[0]}.${myarry[1]}`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {});
  };

  const formatCardAmount = (amount) => {
    if (!amount) return "$0";

    const value = Number(amount);

    if (value >= 1000000000) {
      return `$${(value / 1000000000).toFixed(1)}B`;
    }

    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    }

    if (value >= 1000) {
      return `$${(value / 1000).toFixed(1)}K`;
    }

    return `$${value.toLocaleString()}`;
  };

  const getDisplayName = (metadataValue) => {
    switch (metadataValue) {
      case "XAU":
        return "Gold";
      case "XAG":
        return "Silver";
      case "XPT":
        return "Platinum";
      case "XPD":
        return "Palladium";
      default:
        return metadataValue;
    }
  };
  const getDisplayKeratValue = (keratValue) => {
    switch (keratValue) {
      case "price_gram_24k":
        return "24k";
      case "price_gram_22k":
        return "22k";
      case "price_gram_21k":
        return "21k";
      case "price_gram_20k":
        return "20k";
      case "price_gram_18k":
        return "18";
      case "price_gram_16k":
        return "16";
      case "price_gram_14k":
        return "14k";
      case "price_gram_10k":
        return "10k";
      default:
        return keratValue;
    }
  };

  // show notes popup
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisibleImages, setPopupVisibleImages] = useState(false);
  const [selectedImages, setSelectedImages] = useState("");

  const [selectedNote, setSelectedNote] = useState("");

  const handleOpenPopup = (note) => {
    setSelectedNote(note);
    setPopupVisible(true);
  };

  // for multiple download
  const [popupVisibleDownlaod, setPopupVisibleDownlaod] = useState(false);
  const [selectedDownlaod, setSelectDownload] = useState("");

  const handleShowDownlaod = (showDetail) => {
    setPopupVisibleDownlaod(true);
    setSelectDownload(showDetail);
  };

  const handleShowImages = (showDetail) => {
    setPopupVisibleImages(true);
    setSelectedImages(showDetail);
  };

  // page opening  animation
  const [show, setShow] = useState(false);

  //  form show button
  let [form1, setForm1] = useState(false);

  const [existingJewelryListName, setExistingJewelryListName] = useState(null);
  const [existingIsPartOfNetWorthValue, setExistingIsPartOfNetWorthValue] =
    useState(null);
  const [existingIsPublic, setExistingIsPublic] = useState(null);
  const toggle = (event, value, isPartOfNetWorthValue, closePopup) => {
    setExistingJewelryListName(value);
    setExistingIsPartOfNetWorthValue(isPartOfNetWorthValue);
    setExistingIsPublic(isPublic);
    resetForm();
    if (closePopup) {
      setForm1(false);
      setJewelryListNameValue("");
      setExistingIsPartOfNetWorthValue("");
      return;
    }
    if (value) {
      setForm1(true);
    } else {
      if (jewelryListNameValue !== "") {
        setForm1(false);
      } else {
        setModal(true);
      }
    }
  };

  useEffect(() => {
    if (existingJewelryListName) {
      setJewelries((prevJewelries) =>
        prevJewelries.map((item) => ({
          ...item,
          jewelry: {
            ...item.jewelry,
            jewelryListName: existingJewelryListName, // Set the new jewelryListName
            isPartOfNetWorth: existingIsPartOfNetWorthValue,
            isPublic: existingIsPublic,
          },
        }))
      );
    }
  }, [
    existingJewelryListName,
    existingIsPartOfNetWorthValue,
    existingIsPublic,
  ]);
  // cards
  let [card, setCard] = useState([]); // card = [ {} , {} , {}] - include the form data going to use it for card
  let [showDetail, setShowDetail] = useState([]); // this is to display the card details
  let [show1, setShow1] = useState(false);

  // card creating
  const AddCard = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken(); // Added 'Bearer'
    getJewelries(token, userId)
      .then((res) => {
        setCard(res);
        setJewelries(res);
      })
      .catch((error) => {
        setCard([]);
      });
  };

  // showing the details of cards like popup
  const Showdetails = (obj) => {
    // const arrayFromObject = Object.keys(obj).map(key => obj[key]);
    setShowDetail(obj);
    setShow1(true);
    setIsChecked(
      obj[0].jewelry.isPartOfNetWorth !== null
        ? obj[0].jewelry.isPartOfNetWorth === "true"
          ? true
          : false
        : true
    );
    setIsPublic(obj[0].jewelry.isPublic === "true");
    setExistingJewelryListName(obj[0].jewelry.jewelryListName);
    setIsPublic(obj[0].jewelry.isPublic === "true");
  };

  // beneficiary addition in form
  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    setShow(true);
    AddCard();
    getBenificiarydata();
    getTrustsData();
  }, []);

  // for add field pop
  let [showAdditionField, SetshowAdditionField] = useState(false);
  const [isTextFieldClicked, setIsTextFieldClicked] = useState(false);

  //
  const [benevisible, setbeneVisible] = useState(false);

  const [beneficiaryVisible, setBeneficiaryVisible] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");

  const handleShowBeneficiary = (event, indexValue) => {
    setShow1(false);
    setAssetIndexValue(indexValue);
    setbeneVisible(true);
  };
  const handleOpenBeneficiary = (showDetail) => {
    setSelectedBeneficiary(showDetail);
    setBeneficiaryVisible(true);
  };

  const handleCloseBeneficiaryPopup = (params) => {
    const { name } = params;
    if (name !== undefined) {
      setJewelries((prev) => {
        const updatedJewelries = [...prev];
        updatedJewelries[assetIndexValue].sharedDetails = name;
        return updatedJewelries;
      });
    }
    setbeneVisible(false);
  };

  const handleReset = () => {
    setbeneVisible(false);
  };

  const [trusts, setTrusts] = useState([]);
  const getTrustsData = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getTrustByUserId(token, userId)
      .then((res) => {
        setTrusts(res);
      })
      .catch((err) => {});
  };
  const handleTrustSave = () => {
    setbeneVisible(false);
  };
  const getBenificiaryName = (id) => {
    var foundBenificiary = null;
    if (id.beneficiary === undefined) {
      foundBenificiary = beneficiary.find((b) => b.id === parseInt(id));
    } else {
      foundBenificiary = beneficiary.find(
        (b) => b.id === parseInt(id.beneficiary)
      );
    }
    if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Benificiary not found";
    }
  };

  const uniqueJewelryTypes = [
    ...new Set(
      card
        .map((entity) => entity.jewelry.jewelryName)
        .filter((jewelryName) => jewelryName !== "Other")
    ),
  ];
  const uniqueOtherJewelryTypes = [
    ...new Set(
      card
        .map((entity) => entity.jewelry.otherJewelryName)
        .filter(
          (otherJewelryName) =>
            otherJewelryName !== null && otherJewelryName !== ""
        )
    ),
  ];

  const base64ToBlob = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "image/jpeg" }); // Adjust type if needed
  };

  const addJewelryRow = () => {
    setJewelries((prevJewelries) => [
      ...prevJewelries,
      {
        ...getInitialJewelryData(),
        jewelry: {
          ...getInitialJewelryData().jewelry,
          jewelryListName: prevJewelries[0]?.jewelry.jewelryListName || "",
          isPartOfNetWorth: prevJewelries[0]?.jewelry.isPartOfNetWorth || "",
          isPublic: prevJewelries[0]?.jewelry.isPublic || "false",
        },
        sharedDetails: [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ],
      },
    ]);
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const removeJewelryRow = (index) => {
    setShowConfirmation(true);
    setCurrentIndex(index);
  };

  const handleConfirmation = () => {
    setShowConfirmation(false);
    const index = currentIndex;
    setJewelries(jewelries.filter((_, i) => i !== index));

    setSharedTypeArray((prevSharedTypeArray) =>
      prevSharedTypeArray.filter((_, i) => i !== index)
    );

    setFiles((prevFiles) => {
      const updatedFiles = Object.keys(prevFiles).reduce((acc, key) => {
        const numericKey = parseInt(key, 10);
        if (numericKey !== index) {
          const newIndex = numericKey > index ? numericKey - 1 : numericKey;
          acc[newIndex] = prevFiles[key];
        }
        return acc;
      }, {});

      return updatedFiles;
    });


    // Update ownerName by shifting indices after removal
    setOwnerName((prevOwnerNames) => {
      const updatedOwnerNames = prevOwnerNames.filter((_, i) => i !== index);
      return updatedOwnerNames;
    });
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  // Group and consolidate data
  const consolidated = card.reduce((acc, item) => {
    const listName = item.jewelry.jewelryListName;
    const partOfNetWorthValue = item.jewelry.isPartOfNetWorth;
    const isPublicValue = item.jewelry.isPublic;
    const estimatedValue = parseFloat(item.jewelry.estimatedValue) || 0;

    if (!acc[listName]) {
      acc[listName] = {
        jewelryListName: listName,
        isPartOfNetWorth: partOfNetWorthValue,
        isPublic: isPublicValue,
        estimatedValue: 0,
        data: [],
      };
    }

    acc[listName].estimatedValue += estimatedValue;

    acc[listName].data.push({
      jewelry: item.jewelry,
      documents: item.documents,
      sharedDetails: item.sharedDetails,
      supportingImages: item.supportingImages,
    });

    return acc;
  }, {});

  // Convert consolidated object to an array
  const uniqueJewelryListResult = Object.values(consolidated);

  const [viewDetailFile, setViewDetailFile] = useState(null);
  const uniqueListDocuments = showDetail && Array.isArray(showDetail)
    ? [...new Map(
        showDetail.flatMap(item => item.documents || [])
        .map(doc => [doc.id, doc])
      ).values()]
    : [];

  const handleUnifiedDocumentUpload = () => {
           if (!viewDetailFile) {
             toast.error("Please select a file to upload");
             return;
           }

           const maxFileSize = 4 * 1024 * 1024;

           if (viewDetailFile.size > maxFileSize) {
             toast.error("Please upload a PDF under 4 MB.", {
               position: toast.POSITION.BOTTOM_CENTER,
             });
             return;
           }

           const listName = showDetail[0].jewelry.jewelryListName;
           const token = "Bearer " + getToken();
           const formData = new FormData();

           formData.append("file", viewDetailFile);
           formData.append("listName", listName);

           updateDocumentApi(formData, token)
             .then(() => {
               toast.success("Documents updated successfully!", {
                 position: toast.POSITION.BOTTOM_CENTER,
               });
               setViewDetailFile(null);
               AddCard();
               setShow1(false);
             })
             .catch((error) => {
               console.error(error);
               toast.error("Failed to update documents");
             });
         };

  return (
    <div className={`your-component ${show ? "fade-in-element" : ""}`}>
      <UserBase>
        <div className="mt-5"></div>
        <SideBar>
          {primaryUserDetails.accountType === "secondary" &&
          secondaryUserDetails.accountType === "primary" &&
          secondaryUserDetails.isSecondaryUserEditable === "false" ? (
            ""
          ) : (
            <div className="addme">
              <div className="addme_inner">
                <button onClick={() => toggle()}>Add Jewelry List</button>
              </div>
            </div>
          )}

          <div className="propCard">
            <div class="propCard-card">
              {uniqueJewelryListResult.map((item, index) => (
                <div
                  className="propCard-card-body"
                  style={{ padding: "20px 20px 10px 20px" }}
                >
                  <div className="propCard_card_status">
                    <p
                      className={`propCard_card_status_text ${
                        item.data.every(
                          (dataItem) =>
                            (dataItem.jewelry.trust &&
                              dataItem.jewelry.trust !== "" &&
                              dataItem.jewelry.trust !== null) ||
                            (dataItem.jewelry.beneficiaryName &&
                              dataItem.jewelry.beneficiaryName !== "" &&
                              dataItem.jewelry.beneficiaryName !== null) ||
                            (dataItem.sharedDetails &&
                              dataItem.sharedDetails.length > 0 &&
                              dataItem.sharedDetails[0].distributedType !== "")
                        )
                          ? "completed"
                          : "incomplete"
                      }`}
                    >
                      {item.data.every(
                        (dataItem) =>
                          (dataItem.jewelry.trust &&
                            dataItem.jewelry.trust !== "" &&
                            dataItem.jewelry.trust !== null) ||
                          (dataItem.jewelry.beneficiaryName &&
                            dataItem.jewelry.beneficiaryName !== "" &&
                            dataItem.jewelry.beneficiaryName !== null) ||
                          (dataItem.sharedDetails &&
                            dataItem.sharedDetails.length > 0 &&
                            dataItem.sharedDetails[0].distributedType !== "")
                      )
                        ? "completed"
                        : "incomplete"}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <h5 className="propCard-card-title"
                        style={{
                              flex: 1,
                              minWidth: 0,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          wordBreak: "break-word",
                          lineHeight: "1.3",
                            }}
                            >
                      {item.jewelryListName}
                    </h5>
                    <span style={{ color: "green",
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}>
                      {/*{formatAmount(item.estimatedValue)}*/}
                      {formatCardAmount(item.estimatedValue)}
                    </span>
                  </div>
                  <div className="propCard-btn">
                    <p className="viewDetails">
                      <button
                        className="jewelry_add_more"
                        onClick={(event) =>
                          toggle(
                            event,
                            item.jewelryListName,
                            item.isPartOfNetWorth
                          )
                        }
                      >
                        Add More
                      </button>
                      <button
                        style={{ margin: "10px 0" }}
                        onClick={() => Showdetails(item.data)}
                      >
                        View Details
                      </button>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {form1 && (
            <div
              className="overlay1"
              style={{ transition: "500ms", height: "" }}
            >
              <div>
                <Form onSubmit={jewelryForm} className="addform_body" noValidate>
                  <container>
                    <div className="homepage jewelry_container">
                      <Card>
                        <CardHeader>
                          <div
                            style={{ width: "100%" }}
                            className="addform_heading"
                          >
                            <h3 className="addform_heading_h1">
                              {jewelryListNameValue && jewelryListNameValue}
                              {existingJewelryListName &&
                                existingJewelryListName}
                            </h3>
                            <div
                              className="addform_close"
                              onClick={(event) =>
                                toggle(event, "", "", "close")
                              }
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="jewelry_card_body">
                          <div>
                            <table className="jewelry_table">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th className="jewelry_100px">Owner*</th>
                                  <th className="jewelry_110px">Type*</th>
                                  <th className="jewelry_110px">Name*</th>
                                  <th className="jewelry_90px">
                                    {getColumnTitleForJewelry(
                                      jewelries[0]?.jewelry?.jewelryName
                                    )}
                                  </th>
                                  <th className="jewelry_90px">
                                    Weight (gram / ounce)*
                                  </th>
                                  <th className="jewelry_65px">Qty*</th>
                                  <th className="jewelry_100px">
                                    Rate per Unit Weight*
                                  </th>
                                  <th className="jewelry_100px">
                                    Appraised Val*
                                  </th>
                                  <th>Beneficiary*</th>
                                  <th>Notes</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {jewelries.map((row, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>

                                    <td>
                                      <Select
                                        className="jewelry_select jewelry_100px"
                                        placeholder="Owner"
                                        value={ownerName[index] || []}
                                        multiple
                                        onChange={(event, newValue) =>{
                                          handleChange(
                                            event,
                                            newValue,
                                            "owner",
                                            index,
                                            "jewelry"
                                          )
                                          event?.target?.blur();
                                        }}
                                        // required
                                      >
                                        {ownerNames.map((name) => (
                                          <Option key={name} value={name}>
                                            {name}
                                          </Option>
                                        ))}
                                      </Select>
                                      {errors.owner && (
                                          <div className="text-danger" style={{ fontSize: "12px" }}>
                                            {errors.owner}
                                          </div>
                                      )}
                                    </td>

                                    <td>
                                      <div className="jewelry_select_and_input">
                                        <div>
                                          <Select
                                            className="jewelry_select jewelry_110px"
                                            value={
                                              jewelries[index]?.jewelry
                                                ?.jewelryName || ""
                                            }
                                            onChange={(event, newValue) =>
                                              handleChange(
                                                event,
                                                newValue,
                                                "jewelryName",
                                                index,
                                                "jewelry"
                                              )
                                            }
                                            // required
                                          >
                                            <Option value="">Metal Type</Option>
                                            <Option value="Gold">Gold</Option>
                                            <Option value="Silver">
                                              Silver
                                            </Option>
                                            {/* <Option value="Platinum">
                                              Platinum
                                            </Option> */}
                                            <Option value="Palladium">
                                              Palladium
                                            </Option>
                                            {/* <Option value="Stone">Stone</Option> */}
                                            <Option value="Other">Other</Option>
                                          </Select>
                                          {errors.jewelryName && (
                                              <div className="text-danger" style={{ fontSize: "12px" }}>
                                                {errors.jewelryName}
                                              </div>
                                          )}
                                        </div>
                                        {jewelries[index]?.jewelry
                                          ?.jewelryName === "Other" && (
                                          <div>
                                            <Input
                                              className="jewelry_input jewelry_110px"
                                              placeholder="Other Jewelry Type"
                                              onChange={(e) =>
                                                handleChanges(
                                                  e,
                                                  "otherJewelryName",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.otherJewelryName || ""
                                              }
                                              required={
                                                jewelries[index]?.jewelry
                                                  ?.jewelryName === "Other"
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <Input
                                        className="jewelry_input jewelry_110px"
                                        placeholder="Metal Name"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "jewelryCaption",
                                            index,
                                            "jewelry"
                                          )
                                        }
                                        value={
                                          jewelries[index]?.jewelry
                                            ?.jewelryCaption || ""
                                        }
                                        // required
                                      />
                                      {errors.jewelryCaption && (
                                          <div className="text-danger" style={{ fontSize: "12px" }}>
                                            {errors.jewelryCaption}
                                          </div>
                                      )}
                                    </td>
                                    <td>
                                      {(() => {
                                        const type =
                                          jewelries[index]?.jewelry
                                            ?.jewelryName;

                                        if (type === "Gold") {
                                          return (
                                            <Select
                                              className="jewelry_select jewelry_90px"
                                              placeholder={getPlaceholderForJewelry(
                                                type
                                              )}
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.caratValue || ""
                                              }
                                              onChange={(event, newValue) =>
                                                handleChanges(
                                                  newValue,
                                                  "caratValue",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              required
                                            >
                                              <Option value="">Select</Option>
                                              <Option value="24">24K</Option>
                                              <Option value="22">22K</Option>
                                              <Option value="20">20K</Option>
                                              <Option value="18">18K</Option>
                                              <Option value="16">16K</Option>
                                              <Option value="14">14K</Option>
                                            </Select>
                                          );
                                        } else if (type === "Silver") {
                                          return (
                                            <Select
                                              className="jewelry_select jewelry_130px"
                                              placeholder={getPlaceholderForJewelry(
                                                type
                                              )}
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.caratValue || ""
                                              }
                                              onChange={(e, newValue) =>
                                                handleChanges(
                                                  newValue,
                                                  "caratValue",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              required
                                            >
                                              <Option value="">
                                                Select Purity
                                              </Option>
                                              <Option value="0.999">
                                                Fine Silver (99.9%)
                                              </Option>
                                              <Option value="0.925">
                                                Sterling Silver (92.5%)
                                              </Option>
                                              <Option value="0.9">
                                                Coin Silver (90%)
                                              </Option>
                                            </Select>
                                          );
                                        } else if (type === "Palladium") {
                                          return (
                                            <Select
                                              className="jewelry_select jewelry_130px"
                                              placeholder={getPlaceholderForJewelry(
                                                type
                                              )}
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.caratValue || ""
                                              }
                                              onChange={(e, newValue) =>
                                                handleChanges(
                                                  newValue,
                                                  "caratValue",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              required
                                            >
                                              <Option value="">
                                                Select Purity
                                              </Option>
                                              <Option value="0.999">
                                                99.9%
                                              </Option>
                                              <Option value="0.95">95%</Option>
                                            </Select>
                                          );
                                        } else if (type === "Stone") {
                                          return (
                                            <Input
                                              className="jewelry_input jewelry_110px"
                                              placeholder={getPlaceholderForJewelry(
                                                type
                                              )}
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.stoneGrade || ""
                                              }
                                              onChange={(e) =>
                                                handleChanges(
                                                  e,
                                                  "stoneGrade",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              required
                                            />
                                          );
                                        } else if (type === "Other") {
                                          return (
                                            <Input
                                              className="jewelry_input jewelry_110px"
                                              placeholder={getPlaceholderForJewelry(
                                                type
                                              )}
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.caratValue || ""
                                              }
                                              onChange={(e) =>
                                                handleChanges(
                                                  e,
                                                  "caratValue",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                              required
                                            />
                                          );
                                        } else {
                                          return (
                                            <Input
                                              className="jewelry_input jewelry_110px"
                                              placeholder="Enter Value"
                                              value={
                                                jewelries[index]?.jewelry
                                                  ?.genericValue || ""
                                              }
                                              onChange={(e) =>
                                                handleChanges(
                                                  e,
                                                  "genericValue",
                                                  index,
                                                  "jewelry"
                                                )
                                              }
                                            />
                                          );
                                        }
                                      })()}
                                      {errors.caratValue && (
                                          <div className="text-danger" style={{ fontSize: "12px" }}>
                                            {errors.caratValue}
                                          </div>
                                      )}
                                    </td>
                                    <td>
                                      <div className="jewelry_select_and_input">
                                        <Select
                                          className="jewelry_select jewelry_60px"
                                          value={
                                            jewelries[index]?.jewelry?.unit ||
                                            "gm"
                                          }
                                          onChange={(event, newValue) =>
                                            handleChanges(
                                              newValue,
                                              "unit",
                                              index,
                                              "jewelry"
                                            )
                                          }
                                          required
                                        >
                                          <Option value="gm">gm</Option>
                                          <Option value="oz">oz</Option>
                                        </Select>
                                        <Input
                                          className="jewelry_input jewelry_90px"
                                          type="number"
                                          placeholder="Weight"
                                          value={
                                            jewelries[index]?.jewelry?.weight ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleChanges(
                                              e,
                                              "weight",
                                              index,
                                              "jewelry"
                                            )
                                          }
                                          required
                                        />
                                        {errors.weight && (
                                            <div className="text-danger" style={{ fontSize: "12px" }}>
                                              {errors.weight}
                                            </div>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <Input
                                        className="jewelry_65px"
                                        type="number"
                                        placeholder="Qty"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "quantity",
                                            index,
                                            "jewelry"
                                          )
                                        }
                                        value={
                                          jewelries[index]?.jewelry?.quantity ||
                                          ""
                                        }
                                        required
                                      />
                                      {errors.quantity && (
                                          <div className="text-danger" style={{ fontSize: "12px" }}>
                                            {errors.quantity}
                                          </div>
                                      )}
                                    </td>
                                    <td>
                                      <Input
                                        style={{ width: "140px" }}
                                        className="jewelry_100px"
                                        type="number"
                                        placeholder="value"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "perQuantityValue",
                                            index,
                                            "jewelry"
                                          )
                                        }
                                        value={
                                          jewelries[index]?.jewelry
                                            ?.perQuantityValue || ""
                                        }
                                        startDecorator={<div>$</div>}
                                        disabled={[
                                          "Gold",
                                          "Palladium",
                                          "Silver",
                                        ].includes(
                                          jewelries[index]?.jewelry?.jewelryName
                                        )}
                                        required
                                      />
                                    </td>

                                    <td>
                                      <Input
                                        disabled
                                        className="jewelry_input jewelry_130px"
                                        id={`estimatedValue${index}`}
                                        placeholder="Appraised Value"
                                        type="number"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "estimatedValue",
                                            index,
                                            "jewelry"
                                          )
                                        }
                                        value={
                                          jewelries[index]?.jewelry
                                            ?.estimatedValue || ""
                                        }
                                        onClick={() =>
                                          setIsTextFieldClicked(true)
                                        }
                                        startDecorator={<div>$</div>}
                                        required
                                      />
                                    </td>


                                    <td>
                                      <div
                                        className="bene-select beneficiary_btn"
                                        onClick={(e) =>
                                          handleShowBeneficiary(e, index)
                                        }
                                      >
                                        Beneficiary
                                      </div>
                                      {errors.beneficiary && (
                                          <div
                                              className="text-danger"
                                              style={{ fontSize: "12px" }}
                                          >
                                            {errors.beneficiary}
                                          </div>
                                      )}
                                    </td>
                                    <td>
                                      <Textarea
                                        style={{
                                          fontSize: "14px",
                                        }}
                                        placeholder="Notes"
                                        id="notes"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "notes",
                                            index,
                                            "jewelry"
                                          )
                                        }
                                        value={
                                          jewelries[index]?.jewelry?.notes || ""
                                        }
                                      />
                                    </td>
                                    <td>
                                      <div className="jewelry_action">
                                        {jewelries.length > 1 && (
                                          <Button
                                            className="jewelry_remove_button"
                                            onClick={() =>
                                              removeJewelryRow(index)
                                            }
                                          >
                                            <FontAwesomeIcon icon={faMinus} />
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div style={{ marginTop: "8px" }}>
                              <Button
                                className="jewelry_add_more_button"
                                type="button"
                                onClick={addJewelryRow}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                        <CardFooter>
                          <div className="text-center">
                            <Button
                              className="my-estate-clear-btn"
                              onClick={resetForm}
                              type="reset"
                              outline
                            >
                              Clear
                            </Button>
                            <Button
                              outline
                              type=""
                              className="my-estate-add-btn"
                            >
                              Add
                            </Button>
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  </container>
                </Form>
              </div>
            </div>
          )}
          {modal && (
            <div>
              <Modal
                show={modal}
                toggle={toggleJewelryList}
                style={{ paddingTop: "50px" }}
              >
                <ModalBody style={{ color: "black" }}>
                  Please create your jewelry list here:
                  <div>
                    <Input
                      type="text"
                      value={jewelryListNameValue}
                      placeholder="Enter your jewelry list name"
                      onChange={handleChangeAddJewelryListName}
                    />
                  </div>
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button
                    className="confirm_delete_btn"
                    onClick={handleChangeConfirm}
                  >
                    Add
                  </Button>{" "}
                  <Button
                    className="confirm_cancel_btn"
                    onClick={toggleJewelryList}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
          )}

          {showConfirmation && (
            <ConfirmationPopup
              handleConfirmation={handleConfirmation}
              handleConfirmationClose={handleConfirmationClose}
              anyText="Do you want to remove item from this list?"
            />
          )}

          {showConfirmationDelete && (
            <Deletebutton
              handleRemove={handleRemove}
              Id={currentId}
              idType={currentIdType}
              handleConfirmationClose={handleConfirmationDeleteClose}
            />
          )}

          {show1 && (
            <>
              <div className="popup">
                <div className="popup-content popup-content-download">
                  <div className="note_popup">
                    <div className="note_popup_heading">
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <h2>{`${showDetail[0]?.jewelry?.jewelryListName} Details`}</h2>
                      </div>

                      <div>
                        <button
                          className="note_popup_heading_close_btn"
                          onClick={() => {
                            setShow1(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    </div>
                    <div
                      style={{ margin: "5px" }}
                      className="mt-2 switch_changes_main"
                    >
                      <div className="switch_changes_base">
                        <div>
                          Do you want to include the total list value as part of
                          your net worth?
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isChecked}
                                onChange={(event) => {
                                  handleSwitchChange(event);
                                }}
                                color="primary"
                                size="normal"
                              />
                            }
                            label={isChecked ? "Yes" : "No"}
                            labelPlacement="end"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ margin: "5px" }}
                      className="mt-2 switch_changes_main"
                    >
                      <div className="switch_changes_base">
                        <div>
                          Do you want this asset to be visible to your agent?
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isPublic}
                                onChange={(event) => {
                                  handleSwitchChange1(event);
                                }}
                                color="primary"
                                size="normal"
                              />
                            }
                            label={isPublic ? "Yes" : "No"}
                            labelPlacement="end"
                          />
                        </div>
                      </div>
                    </div>


                    <div
                      style={{ margin: "5px" }}
                      className="mt-2 switch_changes_main"
                    >
                      <div className="switch_changes_base">
                        <div>
                          Upload Document for this List:
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => setViewDetailFile(e.target.files[0])}
                            style={{ maxWidth: '200px' }}
                          />
                          <Button
                            color="primary"
                            size="sm"
                            onClick={handleUnifiedDocumentUpload}
                            disabled={!viewDetailFile}
                          >
                            <FontAwesomeIcon icon={faUpload} className="me-2" />
                            Upload
                          </Button>
                        </div>
                      </div>
                    </div>
{uniqueListDocuments.length > 0 && (
                                                                                                                          <div style={{ margin: "5px" }} className="mt-2 switch_changes_main">
                                                                                                                            <div className="switch_changes_base">
                                                                                                                              <div>Download Documents for this List:</div>
                                                                                                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                                                                                                <div className="me-2">
                                                                                                                                  <Tooltip title="click to see multiple download files">
                                                                                                                                    <div
                                                                                                                                      style={{ cursor: "pointer" }}
                                                                                                                                      onClick={() => {
                                                                                                                                        handleShowDownlaod({ documents: uniqueListDocuments });
                                                                                                                                        setShow1(false);
                                                                                                                                      }}
                                                                                                                                    >
                                                                                                                                      <div className="myestate_download_button dwnbtn">
                                                                                                                                        <FontAwesomeIcon
                                                                                                                                          className="myestate_download_icon"
                                                                                                                                          icon={faDownload}
                                                                                                                                        />
                                                                                                                                        <span></span>
                                                                                                                                      </div>
                                                                                                                                    </div>
                                                                                                                                  </Tooltip>
                                                                                                                                </div>
                                                                                                                              </div>
                                                                                                                            </div>
                                                                                                                          </div>
                                                                                                                        )}

                    <div>
                      {showDetail.map((details, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            padding: "10px",
                            border: "solid 1px lightgray",
                            borderRadius: "5px",
                            minWidth: "230px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Left side */}
                            <div>
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                {`Item - ${index + 1}`}
                                {"  "}
                                <span
                                  className={`propCard_card_status_text ${
                                    (details.jewelry.trust &&
                                      details.jewelry.trust !== "" &&
                                      details.jewelry.trust !== null) ||
                                    (details.jewelry.beneficiaryName &&
                                      details.jewelry.beneficiaryName !== "" &&
                                      details.jewelry.beneficiaryName !==
                                        null) ||
                                    (details.sharedDetails &&
                                      details.sharedDetails.length > 0 &&
                                      details.sharedDetails[0]
                                        .distributedType !== "")
                                      ? "completed"
                                      : "incomplete"
                                  }`}
                                >
                                  {(details.jewelry.trust &&
                                    details.jewelry.trust !== "" &&
                                    details.jewelry.trust !== null) ||
                                  (details.jewelry.beneficiaryName &&
                                    details.jewelry.beneficiaryName !== "" &&
                                    details.jewelry.beneficiaryName !== null) ||
                                  (details.sharedDetails &&
                                    details.sharedDetails.length > 0 &&
                                    details.sharedDetails[0].distributedType !==
                                      "")
                                    ? "completed"
                                    : "incomplete"}
                                </span>
                              </p>
                            </div>
                            {/* Right side */}
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <div className="me-2">
                                  <Tooltip title="Click Here To Edit">
                                    <div>
                                      <UpdateButton
                                        URL={"../my-estate/jewelry/"}
                                        id={details.jewelry.id}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              )}

                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeJewelry(
                                      details.jewelry.id,
                                      "jewelryId"
                                    )
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",

                              flexWrap: "wrap", // Allow wrapping to next line if needed
                            }}
                            className="mt-2"
                          >
                            {/* Left section */}
                            <div style={{ flex: "1", minWidth: "250px" }}>
                              {details.jewelry.owner && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Owner : <span>{details.jewelry.owner}</span>
                                </p>
                              )}

                              <p style={{ color: "black", fontWeight: "500" }}>
                                Metal Type :{" "}
                                <span>
                                  {getDisplayName(
                                    details.jewelry.jewelryName
                                  ) === "Other"
                                    ? details.jewelry.otherJewelryName
                                    : getDisplayName(
                                        details.jewelry.jewelryName
                                      )}
                                </span>
                              </p>

                              <p style={{ color: "black", fontWeight: "500" }}>
                                Metal Name:{" "}
                                <span>{details.jewelry.jewelryCaption}</span>
                              </p>

                              <p style={{ color: "black", fontWeight: "500" }}>
                                Weight(gm):{" "}
                                <span>{details.jewelry.weight}</span>
                              </p>

                              {details.sharedDetails[0] && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                  onClick={() => {
                                    handleOpenBeneficiary(details);
                                    setShow1(false);
                                  }}
                                >
                                  Beneficiary Details{" "}
                                  <span>
                                    <span className="readmore">Click Here</span>
                                  </span>
                                </p>
                              )}

                              {details.jewelry.trust && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Trust Name:{" "}
                                  <span>{details.jewelry.trust}</span>
                                </p>
                              )}

                              {details.jewelry.beneficiaryName && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Beneficiary Name:{" "}
                                  <span>{details.jewelry.beneficiaryName}</span>
                                </p>
                              )}

                              {details.supportingImages &&
                                details.supportingImages.length > 0 && (
                                  <Tooltip title="click to see images">
                                    <p
                                      style={{
                                        color: "black",
                                        fontWeight: "500",
                                      }}
                                      onClick={() => {
                                        handleShowImages(details);
                                        setShow1(false);
                                      }}
                                    >
                                      Jewelry Images{" "}
                                      <span>
                                        <span className="readmore">
                                          Click Here
                                        </span>
                                      </span>
                                    </p>
                                  </Tooltip>
                                )}
                            </div>

                            {/* Right section */}
                            <div style={{ flex: "0.5", minWidth: "250px" }}>
                              <p style={{ color: "black", fontWeight: "500" }}>
                                Quantity:{" "}
                                <span>{details.jewelry.quantity}</span>
                              </p>
                              <p style={{ color: "black", fontWeight: "500" }}>
                                Value/Quantity:{" "}
                                <code
                                  style={{ color: "green", fontWeight: "bold" }}
                                >
                                  {formatAmount(
                                    details.jewelry.perQuantityValue
                                  )}
                                </code>
                              </p>
                              <p style={{ color: "black", fontWeight: "500" }}>
                                Appraised Value:{" "}
                                <code
                                  style={{ color: "green", fontWeight: "bold" }}
                                >
                                  {formatAmount(details.jewelry.estimatedValue)}
                                </code>
                              </p>
                              {details.jewelry.updatedDateAt && (
                                <p style={{ color: "black", fontSize: "13px", marginTop: "6px" }}>
                                  <strong>Last Updated:</strong>{" "}
                                  <span>
                                      {formatDateTimeUS(details.jewelry.updatedDateAt)}
                                  </span>
                                </p>
                              )}

                              {details.jewelry.notes && (
                                <Tooltip title="Click To see Note">
                                  <p
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      handleOpenPopup(details.jewelry.notes);
                                      setShow1(!show1);
                                    }}
                                  >
                                    Note:{" "}
                                    <span>
                                      {" "}
                                      {details && details.jewelry.notes
                                        ? details.jewelry.notes.slice(0, 5)
                                        : ""}
                                      ...
                                      <span className="readmore">
                                        Read More
                                      </span>
                                    </span>
                                  </p>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {popupVisible && (
            // Popup div
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div>
                      <h2>Notes</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisible(false);
                          setShow1(!show1);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>{selectedNote}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {popupVisibleImages && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Jewelry Images</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleImages(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {selectedImages.supportingImages &&
                      selectedImages.supportingImages.length > 0 &&
                      selectedImages.supportingImages.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: "20px",
                            width: "30%",
                            padding: "0 10px",
                          }}
                        >
                          <Tooltip title={image.fileName}>
                            <div style={{ cursor: "pointer" }}>
                              <img
                                key={index}
                                src={URL.createObjectURL(
                                  base64ToBlob(image.file)
                                )}
                                alt={`jewelryImage ${index + 1}`}
                                className="image-item"
                                style={{ width: "100%", height: "auto" }} // Adjust width and height as needed
                              />
                            </div>
                          </Tooltip>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* download popup */}
          {popupVisibleDownlaod && (
            // Popup div

            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* download popup */}
          {popupVisibleDownlaod && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>

                  <div>
                    {selectedDownlaod.documents &&
                      selectedDownlaod.documents.length > 0 &&
                      selectedDownlaod.documents.map((file, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                          <Tooltip title={file.fileName}>
                            <div
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                gap: "20px",
                              }}
                              onClick={() => {
                                handleDownload(file.id, file.fileName);
                              }}
                            >
                              Download - {index + 1}
                              <div className="myestate_download_button dwnbtn">
                                <FontAwesomeIcon
                                  className="myestate_download_icon"
                                  icon={faDownload}
                                />
                                <span>{file.fileName}</span>
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {beneficiaryVisible && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>share property</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setBeneficiaryVisible(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    {selectedBeneficiary.sharedDetails &&
                      selectedBeneficiary.sharedDetails.map(
                        (details, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "5px",
                              padding: "10px",
                              border: "solid 1px lightgray",
                              borderRadius: "5px",
                              minWidth: "230px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                Share - {index + 1}
                              </p>
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeJewelry(details.id, "sharedDetailId")
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "20px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Beneficiary Name:
                                <span style={{ marginLeft: "10px" }}>
                                  {getBenificiaryName(details.beneficiaryId)}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Type:
                                <span style={{ marginLeft: "10px" }}>
                                  {details.distributedType}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Value:{" "}
                                <span style={{ marginLeft: "10px" }}>
                                  {details &&
                                    details.distributedType === "dollar" &&
                                    "$"}
                                  {details.distributedValue}
                                  {details.distributedType === "percentage" &&
                                    "%"}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Amount:
                                <span style={{ marginLeft: "10px" }}>
                                  {formatAmount(details.distributedAmount)}
                                </span>
                              </p>
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {showAdditionField && (
            // Display the popup when a row is selected
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup_heading">
                  <div>
                    <h2>All Additional Field</h2>
                  </div>
                  <div>
                    <button
                      className="note_popup_heading_close_btn"
                      onClick={() => {
                        SetshowAdditionField(false);
                        setShow1(!show1);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </div>
                <div className="popup-body">
                  {showAdditionField.addfield1 !== 0 &&
                  showAdditionField.addfield1 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 1 : {showAdditionField.addfield1}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield2 !== 0 &&
                  showAdditionField.addfield2 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 2 : {showAdditionField.addfield2}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield3 !== 0 &&
                  showAdditionField.addfield3 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 3 : {showAdditionField.addfield3}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield4 !== 0 &&
                  showAdditionField.addfield4 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 4 : {showAdditionField.addfield4}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield5 !== 0 &&
                  showAdditionField.addfield5 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 5 : {showAdditionField.addfield5}
                    </p>
                  ) : (
                    <p></p>
                  )}
                </div>
              </div>
            </div>
          )}

          {benevisible && (
            <SharedBeneficiary
              assetName={"jewelry"}
              handleTrustSave={handleTrustSave}
              assetIndexValue={assetIndexValue}
              assetData={jewelries[assetIndexValue]?.jewelry}
              trusts={trusts}
              handleChanges={handleChanges}
              sharedType={sharedTypeArray[assetIndexValue]}
              handleCloseBeneficiaryPopup={handleCloseBeneficiaryPopup}
              estimatedTotalAmount={
                jewelries[assetIndexValue]?.jewelry?.estimatedValue
              }
              typeBeneficiary={"normal"}
              sharedDetails={jewelries[assetIndexValue]?.sharedDetails}
            />
          )}
        </SideBar>
      </UserBase>
    </div>
  );
}

export default JewelryList;